import { proposalsService } from '@/services/proposals';
import { homeownerQuotesService } from '@/services/quotes/homeowner';
import { downloadFromSignedUrl } from '@/shared/utils/signed-url.util';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type Payload = {
  productCode: string;
  stage: 'proposal' | 'quote';
};

export function useProposalsGeneratePdf(proposalId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: Payload) => {
      if (payload.stage === 'proposal') {
        const response = await proposalsService.generatePdf(
          proposalId,
          {
            productCode: payload.productCode,
            stage: 'proposal',
          },
          payload.productCode
        );
        if (!response.success || !response.data) {
          throw new Error(response.error || 'Erro ao gerar PDF da proposta');
        }
        // Faz download usando a URL já assinada
        const filename = response.data.key.split('/').pop() || `proposta-${proposalId}.pdf`;
        await downloadFromSignedUrl(response.data.url, filename);
      } else {
        const response = await homeownerQuotesService.getProposalPdf({
          policyId: proposalId,
          productCode: payload.productCode,
          stage: 'quote',
        });
        if (!response.success || !response.data) {
          throw new Error(response.error || 'Erro ao gerar PDF da proposta');
        }
        // Faz download usando a URL já assinada
        const filename = response.data.key.split('/').pop() || `cotacao-${proposalId}.pdf`;
        await downloadFromSignedUrl(response.data.url, filename);
      }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['proposal', proposalId, 'pdf'],
      });
    },
  });
}
